import Raven from 'raven-js'
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { middleware as asynchMiddleware } from 'redux-asynch-middleware'
import createSagaMiddleware from 'redux-saga'
import { bindGooseToSagaMiddleware, loadModule, gooseMiddleware } from './goose'
import { connectRouter, routerMiddleware } from 'connected-react-router'

import RootModule from './modules/root'
import { middleware as asyncActionMiddleware } from './action'

function configureStore(initialState,history) {
  const sagaMiddleware = createSagaMiddleware({
    onError: (e) => {
      // Report uncaught exceptions in sagas.
      Raven.captureException(e)
    }
  })

  const bindRoutingToReducer = connectRouter(history)
  const bindExtraReducers = compose(bindRoutingToReducer)

  const store = createStore(
      x => x,
      initialState,
      compose(
        applyMiddleware(
          thunk,
          asynchMiddleware,
          asyncActionMiddleware,
          sagaMiddleware,
          gooseMiddleware,
          routerMiddleware(history)
        ),
        window.devToolsExtension ? window.devToolsExtension() : f => f
    )
  )

	// Kick off the root module
  bindGooseToSagaMiddleware(sagaMiddleware,(newReducer) => (
    store.replaceReducer(bindExtraReducers(newReducer))
  ))
  store.dispatch(loadModule(RootModule))

  return store;
}

export default configureStore



// WEBPACK FOOTER //
// ./src/redux/store.js